import React from 'react';
import Layout from '../components/Layout/Layout';

// Import campus life images
import libraryImg from '../images/campus-cafeteria.jpeg';
import discussionImg from '../images/campus-diss.jpeg';
import greeneryImg from '../images/campus-grenary.jpeg';
import cafeteriaImg from '../images/study-image.jpeg';
import sportsImg from '../images/campus-sportspractice.jpeg';
import labImg from '../images/campus-lab-experment.jpeg';
import facultyImg from '../images/faculty-interaction.jpeg';
import clubImg from '../images/student-club.jpeg';

const CampusLifePage = () => {
  const images = [
    { title: 'Students studying in library', image: libraryImg },
    { title: 'Students engaged in group discussion', image: discussionImg },
    { title: 'Lush green campus grounds', image: greeneryImg },
    { title: 'Students enjoying a break in cafeteria', image: cafeteriaImg },
    { title: 'Students playing outdoor sports', image: sportsImg },
    { title: 'Students conducting experiment in lab', image: labImg },
    { title: 'Faculty interacting with students', image: facultyImg },
    { title: 'Student club meeting on campus', image: clubImg }
  ];

  return (
    <Layout>
      <div id="campus-life" className="page-container" style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <h2 style={{ color: '#004d99', borderBottom: '1px solid #90cdf4', paddingBottom: '20px', marginBottom: '30px', textAlign: 'center', fontSize: '2.8rem', fontWeight: 'bold' }}>
          Campus Life Gallery
        </h2>

        <p style={{ color: '#444', textAlign: 'center', maxWidth: '900px', margin: '0 auto 40px', lineHeight: '1.6', fontSize: '1.1rem' }}>
          Experience the vibrant and engaging atmosphere of G.S. Tompe Arts, Commerce & Science College through these snapshots of daily campus life, showing student interactions, academic pursuits, and recreational activities.
        </p>

        <div style={{ 
          backgroundColor: '#333', 
          borderLeft: '6px solid #0056b3', 
          padding: '40px', 
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '30px'
          }}>
            {images.map((item, index) => (
              <div key={index} style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <div style={{ height: '300px', overflow: 'hidden' }}>
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                  />
                </div>
                <div style={{ 
                  backgroundColor: '#fff', 
                  padding: '20px', 
                  textAlign: 'center', 
                  fontSize: '1.05rem', 
                  fontWeight: '700', 
                  color: '#004d99' 
                }}>
                  {item.title}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ 
          marginTop: '40px', 
          backgroundColor: '#f8f9fa', 
          borderLeft: '4px solid #0056b3', 
          padding: '20px 30px', 
          borderRadius: '4px',
          color: '#555',
          fontStyle: 'italic',
          fontSize: '1rem'
        }}>
          Our campus is always buzzing with activity! Stay tuned for more glimpses into student life.
        </div>

      </div>
    </Layout>
  );
};

export default CampusLifePage;
